import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, WorkflowData } from '../../../../../applications/models/applications.models';
import { IUploadFile } from '../../../../../common/services/document-management.service';
import { AuthService } from '../../../../../services/auth.service';
import { ComplianceReportingType } from '../../../../models/compliance.model';

@Component({
    selector: 'app-documentation',
    templateUrl: './documentation.component.html',
    styleUrls: ['./documentation.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class DocumentationComponent extends ApplicationSectionBaseComponent implements OnInit {

    @Input() form: FormGroup;
    @Input() reportType: ComplianceReportingType;
    @Input() application: WorkflowData;

    inputStates: ApplicationState[] = [
        ApplicationState.Input,
        ApplicationState.Start,
    ];


    get cementTicketsCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('cementTickets');
    }

    get cementTicketsFiles(): IUploadFile[] {
        if (this.cementTicketsCtrl == null) return [];
        return <IUploadFile[]>this.cementTicketsCtrl.value;
    }

    get cementJobLogsCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('cementJobLogs');
    }

    get cementJobLogsFiles(): IUploadFile[] {
        if (this.cementJobLogsCtrl == null) return [];
        return <IUploadFile[]>this.cementJobLogsCtrl.value;
    }

    get safetyDateSheetCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('safetyDateSheet');
    }

    get safetyDateSheetFiles(): IUploadFile[] {
        if (this.safetyDateSheetCtrl == null) return [];
        return <IUploadFile[]>this.safetyDateSheetCtrl.value;
    }

    get cementDataCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('cementData');
    }

    get cementDataFiles(): IUploadFile[] {
        if (this.cementDataCtrl == null) return [];
        return <IUploadFile[]>this.cementDataCtrl.value;
    }

    get prGraphCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('prGraph');
    }

    get prGraphFiles(): IUploadFile[] {
        if (this.prGraphCtrl == null) return [];
        return <IUploadFile[]>this.prGraphCtrl.value;
    }

    get stimInvoiceCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('stimInvoice');
    }

    get stimInvoiceFiles(): IUploadFile[] {
        if (this.prGraphCtrl == null) return [];
        return <IUploadFile[]>this.stimInvoiceCtrl.value;
    }

    get stimRecordCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('stimRecord');
    }

    get stimRecordFiles(): IUploadFile[] {
        if (this.stimRecordCtrl == null) return [];
        return <IUploadFile[]>this.stimRecordCtrl.value;
    }

    get stimLogCtrl(): AbstractControl {
        if (this.form == null) return null;
        return <AbstractControl>this.form.get('stimLog');
    }

    get stimLogFiles(): IUploadFile[] {
        if (this.stimLogCtrl == null) return [];
        return <IUploadFile[]>this.stimLogCtrl.value;
    }

    get isInternal(): boolean {
        return this._auth.User.isInternal;
    }


    constructor(public _auth: AuthService) {
        super(_auth);
    }

    ngOnInit() {}
    cementTicketFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.cementTicketsFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Record of Casing, Cementing";
            files.push(evt);
            this.cementTicketsCtrl.setValue(files);
        }
    }

    cementTicketFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.cementTicketsFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.cementTicketsCtrl.setValue(files);
        }
    }

    cementJobLogFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.cementJobLogsFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - FEWC-Cement Job Log";
            files.push(evt);
            this.cementJobLogsCtrl.setValue(files);
        }
    }

    cementJobLogFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.cementJobLogsFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.cementJobLogsCtrl.setValue(files);
            
        }
    }

    safetyDateSheetFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.safetyDateSheetFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Safety Data Sheets";
            files.push(evt);
            this.safetyDateSheetCtrl.setValue(files);
        }
    }

    safetyDateSheetFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.safetyDateSheetFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.safetyDateSheetCtrl.setValue(files);
        }
    }

    cementDataFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.cementDataFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Other Cement Data";
            files.push(evt);
            this.cementDataCtrl.setValue(files);
        }
    }

    cementDataFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.cementDataFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.cementDataCtrl.setValue(files);
        }
    }

    prGraphFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.prGraphFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-P-R Graph";
            files.push(evt);
            this.prGraphCtrl.setValue(files);
        }
    }

    prGraphFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.prGraphFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.prGraphCtrl.setValue(files);
        }
    }

    stimInvoiceFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.stimInvoiceFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Stimulation Invoice";
            files.push(evt);
            this.stimInvoiceCtrl.setValue(files);
        }
    }

    stimInvoiceFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.stimInvoiceFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.stimInvoiceCtrl.setValue(files);
        }
    }

    stimRecordFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.stimRecordFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Stimulation Record";
            files.push(evt);
            this.stimRecordCtrl.setValue(files);
        }
    }

    stimRecordFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.stimRecordFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.stimRecordCtrl.setValue(files);
        }
    }

    stimLogFileAdded(evt: IUploadFile): void {
        const files: IUploadFile[] = this.stimLogFiles;
        const isNew = files.findIndex(l => l.fileName === evt.fileName) === -1;
        if (isNew) {
            evt.documentType = "DNR - OG - PRMT-Stimulation Log";
            files.push(evt);
           this.stimLogCtrl.setValue(files);
        }
    }

    stimLogFileRemoved(evt: IUploadFile): void {
        const files: IUploadFile[] = this.stimLogFiles;
        const fileIndex = files.findIndex(l => l.fileName === evt.fileName);
        if (fileIndex !== -1) {
            files.splice(fileIndex, 1);
            this.stimLogCtrl.setValue(files);
        }
    }

    allowFileManipulation(fieldName: string): boolean {
        if (this.application != null) {

            if (this.inputStates.includes(this.applicationState)) {
                return true;
            }

            else if (this.applicationState == ApplicationState.Corrections && this.fieldHasNotes(`documentation|${fieldName}`)) {

                return true;
            }

            return false;

        }

        return true;
    }


}
